import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Contact Info */}
          <div>
            <h2 className="text-xl font-semibold mb-4">
              Northern / Central Valley - eXp Realty of Northern California, Inc. CA DRE#02188495
            </h2>
            <address className="not-italic mb-4">
              915 Highland Pointe Dr Ste 250<br />
              Roseville, CA 95678<br />
            </address>
            <p className="mb-4">
              <a href="tel:916-257-8244" className="hover:text-blue-400 transition-colors">
                916-257-8244
              </a>
            </p>
            <div className="mb-4">
              <p className="font-semibold mb-2">Additional:</p>
              <address className="not-italic">
                PO Box 1194<br />
                Folsom, CA 95763<br />
              </address>
            </div>
            <p className="text-sm mb-4">
              Should you require assistance in navigating our website or searching for real estate,
              please contact our offices at{' '}
              <strong>
                <a href="tel:928-963-2760" className="hover:text-blue-400 transition-colors">
                  928-963-2760
                </a>
              </strong>
              .
            </p>
            <p className="mb-4">CA License # CA DRE# 02234432</p>
            <div className="mb-4 flex items-center gap-3">
              <p>Member ID Number (NRDS): 192079153</p>
              <img 
                src="https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/8eeb75bc263dd70d0ece59eca9199b8c.png" 
                alt="REALTOR Logo" 
                className="h-8 w-auto"
              />
            </div>
            <div className="mb-6">
              <strong>eXp Realty of Northern California, Inc. CA DRE#02188495</strong>
            </div>
            
            {/* Corporate Headquarters */}
            <div className="mb-6 p-4 bg-gray-800 rounded-lg">
              <h3 className="font-bold text-lg mb-2" style={{ fontFamily: '"Eurostile Extended", "Arial Black", sans-serif' }}>
                Corporate Headquarters
              </h3>
              <address className="not-italic">
                725 E Road 2 N Unit 1494<br />
                Chino Valley, AZ 86323
              </address>
            </div>
          </div>

          {/* Right Column - MLS Disclaimer */}
          <div>
            <h2 className="text-xl font-semibold mb-4">MLS® Disclaimer</h2>
            <div className="mb-4">
              <img 
                alt="MLS Logo" 
                src="https://d9la9jrhv6fdd.cloudfront.net/mlslogos/47.png" 
                className="mb-4"
              />
            </div>
            <p className="text-sm leading-relaxed">
              All measurements and all calculations of area are approximate. Information provided by Seller/Other sources, not verified by Broker. All interested persons should independently verify accuracy of information. Provided properties may or may not be listed by the office/agent presenting the information. Data maintained by MetroList© may not reflect all real estate activity in the market.
            </p>
            <p className="text-sm leading-relaxed mt-4">
              All real estate content on this site is subject to the Federal Fair Housing Act of 1968, as amended, which makes it illegal to advertise any preference, limitation or discrimination because of race, color, religion, sex, handicap, family status or national origin or an intention to make any such preference, limitation or discrimination.
            </p>
            <p className="text-sm leading-relaxed mt-4">
              MetroList CA data last updated: November 16, 2025 4:37 PM UTC{' '}
              <a 
                href="https://drive.google.com/file/d/1wGxyzWtCO8CKUxJ-thoL9j4KfKi5fDNY/view?usp=sharing" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                Terms of Use
              </a>
              .
            </p>
            <p className="text-sm mt-4">
              Vendor data provided by Inside Real Estate, LLC.
            </p>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          {/* Footer Navigation */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
            {/* Main Pages */}
            <div>
              <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Main Pages</h3>
              <ul className="space-y-2.5">
                <li><a href="/" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Home</a></li>
                <li><a href="/sell" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Sell Your Home</a></li>
                <li><a href="/finance" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Finance</a></li>
                <li><a href="/agents" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Our Team</a></li>
                <li><a href="/contact" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Contact</a></li>
                <li><a href="/booking" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Book Appointment</a></li>
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Resources</h3>
              <ul className="space-y-2.5">
                <li><a href="/blog" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Blog</a></li>
                <li><a href="/resources" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Resources</a></li>
                <li><a href="/toolkits" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Toolkits</a></li>
                <li><a href="/faq" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">FAQ</a></li>
                <li><a href="/backoffice" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Backoffice</a></li>
                <li><a href="/az-tax-sales" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">AZ Tax Sales</a></li>
                <li>
                  <a
                    href="https://businessdevelopmentauthority.net/ca-tax-foreclosures"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer"
                  >
                    CA Tax Foreclosures
                  </a>
                </li>
              </ul>
            </div>

            {/* External Links */}
            <div>
              <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Quick Links</h3>
              <ul className="space-y-2.5">
                <li><a href="https://joinapp.exprealty.com/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Join My Team</a></li>
                <li><a href="https://jefferylong.exprealty.com/index.php?showagent=1&rtype=map" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Home Search</a></li>
                <li><a href="https://www.join-exp.world" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">Agent Presentation</a></li>
                <li><a href="https://jefferylong.exprealty.com/index.php?showagent=1#rslt" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">My Listings</a></li>
                <li><a href="https://jefferylong.buildersupdate.com/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm cursor-pointer">New Construction</a></li>
              </ul>
            </div>

            {/* Connect */}
            <div>
              <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Connect</h3>
              <div className="flex items-center space-x-3 mb-4">
                <a href="https://www.facebook.com/profile.php" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="fab fa-facebook-f text-sm"></i>
                </a>
                <a href="https://www.twitter.com/JeffL_eXpRealty" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="fab fa-twitter text-sm"></i>
                </a>
                <a href="https://www.linkedin.com/in/jeffery-long-355a73352/" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="fab fa-linkedin-in text-sm"></i>
                </a>
                <a href="https://www.youtube.com/@realestatedevelopmentautho3005" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="fab fa-youtube text-sm"></i>
                </a>
                <a href="https://www.instagram.com/jeffery_long_exp_realty0223443/" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="fab fa-instagram text-sm"></i>
                </a>
              </div>
              <p className="text-gray-400 text-sm mb-1">Call us today:</p>
              <a href="tel:916-257-8244" className="text-emerald-400 hover:text-emerald-300 transition-colors font-semibold cursor-pointer">916-257-8244</a>
            </div>
          </div>

          {/* Copyright Bar */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex flex-col lg:flex-row justify-between items-center">
              <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-4 lg:mb-0">
                <li>
                  <a 
                    href="https://insiderealestate.com" 
                    rel="noopener noreferrer nofollow"
                    className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer"
                  >
                    © 2025 Inside Real Estate
                  </a>
                </li>
                <li>
                  <a href="/terms" className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="/privacy" className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/accessibility" className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer">
                    Accessibility
                  </a>
                </li>
                <li>
                  <a href="/fair-housing" className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer">
                    Fair Housing Statement
                  </a>
                </li>
                <li>
                  <img 
                    alt="Equal Housing Logo" 
                    src="https://d9la9jrhv6fdd.cloudfront.net/images/fair.png" 
                    width="20" 
                    height="20"
                  />
                </li>
              </ul>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs text-gray-500 hover:text-gray-300 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}